import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from '../components/Sidebar';
import GameMenu from '../components/GameMenu';
import Timer from '../components/Timer';
import '../assets/css/fillthegap.css'
import Popup from '../components/Popup';
import LeaveGamePopup from '../components/LeaveGamePopup';
import EndGameBtn from "../components/EndGameBtn";
// import AnimatedBg from "../components/AnimatedBg";
import api from "../api/client";

export default function FillTheGap() {
    const [isFillTheGap] = useState(true);
    const [timerIsFinished, setTimerIsFinished] = useState(false);
    const [timeElapsed, setTimeElapsed] = useState(0);

    const sendTime = (time) => {
        setTimeElapsed(time);
    };

    const getTimerTimeRef = useRef(null);

    const [leaveGamePopup, setLeaveGamePopup] = useState(false);

    const sendLeaveGame = (value) => {
        setLeaveGamePopup(value);
    };

    // IMPORTANT :
    // on déclare location/theme/subTheme/level AVANT le useEffect
    // pour éviter "Cannot access 'F' before initialization" après build.
    const location = useLocation();
    const { theme, subTheme, level = "B1" } = location.state || {};

    // ── Chargement depuis l'API ──────────────────────────────────────
    const [wordsAndSentences, setWordsAndSentences] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiError, setApiError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        setLoading(true);
        setApiError(null);

        const params = new URLSearchParams({ level: level || "B1", n: 8 });
        if (theme) params.append("theme", theme);
        if (subTheme) params.append("sous_theme", subTheme);

        api.get(`/api/games/fill-in-blank/?${params.toString()}`)
            .then(({ data }) => {
                if (cancelled) return;

                const formatted = (data.items || []).map(item => ({
                    word: item.answer,
                    trad: item.translation_fr || item.answer,  //  FIX : traduction FR pour le survol
                    parts: String(item.sentence || "").split("_____"),
                }));

                setWordsAndSentences(formatted);
                setLoading(false);
            })
            .catch((err) => {
                if (cancelled) return;
                setApiError(err.message);
                setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [theme, subTheme, level]);
    // ────────────────────────────────────────────────────────────────

    const [availableWords, setAvailableWords] = useState([]);
    const [placedWords, setPlacedWords] = useState({});
    const [errorCount, setErrorCount] = useState(0);

    // eslint-disable-next-line no-unused-vars
    function parseSentenceToParts(sentence) {
        const regex = /(<span[^>]*>_____<\/span>)/g;
        const rawParts = sentence.split(regex);

        return rawParts.map(part => {
            if (part.includes("_____")) {
                return "_____";
            }
            return part.replace(/<\/?[^>]+(>|$)/g, "");
        });
    }


    // ── Enregistrement session ────────────────────────────────────────
    const saveSession = async (timeSeconds, errors) => {
        const total = shuffledSentences.length;
        const wrong = errors !== undefined ? errors : errorCount;
        const correct = total - wrong;
        try {
            await api.post('/api/gameplay/session/', {
                game_code:    'fill_in_blank',
                theme:        theme,
                sous_theme:   subTheme,
                level:        level,
                score:        correct,
                total:        total,
                correct:      correct,
                wrong:        wrong,
                time_seconds: timeSeconds || timeElapsed,
            });
        } catch (e) {
            console.warn('Session non enregistree :', e);
        }
    };

    const validateAnswers = () => {
        let errors = 0;

        const droppables = document.querySelectorAll(".droppable");

        droppables.forEach((el) => {
            const sentenceIndex = parseInt(
                el.closest("p").getAttribute("data-sentenceindex"),
                10
            );

            const key = `${sentenceIndex}-0`;
            const expectedWord = shuffledSentences[sentenceIndex]?.word;
            const userWord = placedWords[key];

            if (userWord === expectedWord) {
                el.classList.remove("wrong");
                el.classList.add("correct");
            } else {
                el.classList.remove("correct");
                el.classList.add("wrong");
                errors++;
            }
        });

        setErrorCount(errors);
    };

    const [correctionMode, setCorrectionMode] = useState(false); // eslint-disable-line no-unused-vars

    const handleCorrection = () => {
        console.log("Correction demandée !");
        setCorrectionMode(true);
        setTimerIsFinished(false);

        const wrongEls = document.querySelectorAll(".droppable.wrong");
        const wordsToRestore = [];
        const keysToRemove = [];

        wrongEls.forEach((el) => {
            const sentenceIndex = parseInt(
                el.closest("p").getAttribute("data-sentenceindex"),
                10
            );

            const key = `${sentenceIndex}-0`;
            const wrongWord = placedWords[key];

            if (wrongWord) {
                wordsToRestore.push(wrongWord);
                keysToRemove.push(key);
            }

            el.classList.remove("wrong", "correct", "filled");
        });

        setPlacedWords(prev => {
            const updated = { ...prev };
            keysToRemove.forEach(key => delete updated[key]);
            return updated;
        });

        setAvailableWords(prev => [...prev, ...wordsToRestore]);
    };

    function shuffleArray(array) {
        return [...array].sort(() => Math.random() - 0.5);
    }

    const [shuffledSentences, setShuffledSentences] = useState([]);

    useEffect(() => {
        if (wordsAndSentences.length === 0) return;
        const sentences = shuffleArray(wordsAndSentences);
        setShuffledSentences(sentences);
        setAvailableWords(wordsAndSentences.map(w => w.word));
        setPlacedWords({});
    }, [wordsAndSentences]);

    // useEffect(() => {
    //     const droppables = document.querySelectorAll('.droppable');
    //     const cleanups = [];

    //     droppables.forEach(el => {
    //         const onDragOver = (e) => {
    //             e.preventDefault(); // autorise le drop
    //             el.classList.add('drag-over');
    //         };

    //         const onDragLeave = () => {
    //             el.classList.remove('drag-over');
    //         };

    //         const onDrop = (e) => {
    //             e.preventDefault();
    //             el.classList.remove('drag-over');
    //             const droppedWord = e.dataTransfer.getData('text/plain');
    //             if (!droppedWord || el.textContent.trim() !== "_____") return;
    //             el.textContent = droppedWord;
    //             el.classList.add('filled');
    //             setAvailableWords(prev => prev.filter(w => w !== droppedWord));
    //         };

    //         el.addEventListener('dragover', onDragOver);
    //         el.addEventListener('dragleave', onDragLeave);
    //         el.addEventListener('drop', onDrop);

    //         cleanups.push(() => {
    //             el.removeEventListener('dragover', onDragOver);
    //             el.removeEventListener('dragleave', onDragLeave);
    //             el.removeEventListener('drop', onDrop);
    //         });
    //     });

    //     return () => {
    //         cleanups.forEach(fn => fn());
    //     };
    // }, [shuffledSentences]);

    // eslint-disable-next-line no-unused-vars
    const lineAnimation = {
        rotate: [0, 5, -5, 0],
        scale: [1, 1.05, 0.95, 1],
        transition: {
            duration: 10,
            ease: "easeInOut",
            repeat: Infinity,
        },
    };
    // eslint-disable-next-line no-unused-vars
    const circleAnimation = {
        y: [0, -10, 0, 10, 0],
        transition: {
            duration: 8,
            ease: "easeInOut",
            repeat: Infinity,
        },
    };
    // eslint-disable-next-line no-unused-vars
    const circleAnimationDelayed = {
        ...circleAnimation,
        transition: {
            ...circleAnimation.transition,
            delay: 2,
        },
    };

    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container inGame" id="fillTheGap">
                <div className="title">
                    <h4>{theme} - {subTheme}</h4>
                    <div className="level-infos">
                        <Timer
                            timer={timerIsFinished}
                            onFinish={() => {
                                validateAnswers()
                                setTimerIsFinished(true)
                            }}
                            onSendTime={sendTime}
                            onGetTime={(getTimeFn) => getTimerTimeRef.current = getTimeFn}
                            hasLimit={false}
                        />
                    </div>
                </div>

                <div className="game-container launched">
                    {loading && <p>Chargement...</p>}
                    {apiError && <p>Erreur : {apiError}</p>}

                    <div id="words-container" className="word-container">
                        {availableWords.map((word, index) => {
                            const original = wordsAndSentences.find(w => w.word === word);
                            const trad = original ? original.trad : word;

                            return (
                                <span
                                    key={index}
                                    className="draggable draggable-HoverEffects movable word"
                                    draggable
                                    onDragStart={(e) => e.dataTransfer.setData("text/plain", word)}
                                    onMouseEnter={(e) => e.currentTarget.textContent = trad}
                                    onMouseLeave={(e) => e.currentTarget.textContent = word}
                                >
                                    {word}
                                </span>
                            )
                        })}
                    </div>

                    <div id="phrases-container" className="flex-grow-1">
                        {shuffledSentences.map(({ parts }, sentenceIndex) => {
                            const key = `${sentenceIndex}-0`;
                            const currentWord = placedWords[key];

                            return (
                                <p key={sentenceIndex} data-sentenceindex={sentenceIndex}>
                                    {sentenceIndex + 1}.{" "}

                                    <span>{parts[0]}</span>

                                    <span
                                        className={`droppable ${currentWord ? "filled" : ""}`}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => {
                                            e.preventDefault();
                                            const droppedWord = e.dataTransfer.getData("text/plain");

                                            if (!droppedWord || currentWord) return;

                                            setPlacedWords(prev => ({
                                                ...prev,
                                                [key]: droppedWord
                                            }));

                                            setAvailableWords(prev =>
                                                prev.filter(w => w !== droppedWord)
                                            );
                                        }}
                                        onClick={() => {
                                            if (currentWord) {
                                                setPlacedWords(prev => {
                                                    const updated = { ...prev };
                                                    delete updated[key];
                                                    return updated;
                                                });

                                                setAvailableWords(prev => [...prev, currentWord]);
                                            }
                                        }}
                                    >
                                        {currentWord || " "}
                                    </span>

                                    <span>{parts[1]}</span>
                                </p>
                            );
                        })}
                    </div>
                </div>

                <EndGameBtn onClick={async () => {
                    const t = getTimerTimeRef.current ? getTimerTimeRef.current() : timeElapsed;
                    sendTime(t);
                    validateAnswers();
                    await saveSession(t);
                    setTimerIsFinished(true);
                }} />
            </div>

            {/* <AnimatedBg /> */}
            <GameMenu onSendLeaveGame={sendLeaveGame} />
            <Popup
                time={timeElapsed}
                timerIsFinished={timerIsFinished}
                errorCount={errorCount}
                isFillTheGap={isFillTheGap}
                onCorrection={handleCorrection}
            />
            <LeaveGamePopup popupOpen={leaveGamePopup} onSendLeaveGame={sendLeaveGame} />
        </div>
    )
}